import { setShowClientModal } from '../State/showClientModal';
import fetchClient from '../Services/fetchClient';

export default () => async (dispatch) => {
  
  dispatch(fetchClient());
  dispatch(setShowClientModal(false));
  
  
}